import { render } from "./TeamPart.vue?vue&type=template&id=4eba2047"
import script from "./TeamPart.vue?vue&type=script&lang=js"
export * from "./TeamPart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__